<template>
    <section class="profile-dashboard">
        <div class="profile-dashboard__user">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="profile-dashboard__stories">
                            <story-line v-if="stories" :stories="stories"/>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-9">
                        <info :user="user" :dashboard="dashboard" />
                    </div>
                    <div class="col-md-6" v-if="media < 992 && dashboard">
                        <meta-info :dashboard="dashboard" :user="user"/>
                    </div>
                    <div class="col-12 col-sm-12 col-md-6 col-lg-3">
                        <date-picker :lang="lang" :inline="true" :open="true"
                                     v-model="date" value-type="format" format="YYYY-MM-DD HH:mm:ss" :placeholder="$store.getters.t('user_dashboard_from_date')"></date-picker>
                    </div>
                </div>
                <div class="row" v-if="media >=992 && dashboard">
                    <div class="col-md-12">
                        <meta-info :dashboard="dashboard" :user="user" />
                    </div>
                </div>
            </div>
        </div>
        <div class="profile-dashboard__pets">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-8">
                        <pets :user="user" />
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 col-lg-4">
                        <transactions :user="user" />
                    </div>
                </div>
            </div>
        </div>
        <div class="profile-dashboard__pets">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-8">
                        <projects :user="user" />
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 col-lg-4">
                        <payments :user="user"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="profile-dashboard__pets">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-8">
                        <pets-self :user="user" />
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 col-lg-4">
                        <follows :user="user" />
                    </div>
                </div>
            </div>
        </div>
        <div class="profile-dashboard__subscriptions">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <subscriptions />
                    </div>
                </div>
            </div>
        </div>
        <div class="profile-dashboard__desk">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 col-lg-8">
                        <notifications :user="user" />
                    </div>
                    <div class="col-md-12 col-lg-4">
                        <facilities :user="user" />
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>

import {mapGetters,mapActions} from 'vuex'

import StoryLine from './../../StoryLine'
import Info from './UserDashboardInfo'
import MetaInfo from './UserDashboardMeta'
import Pets from './UserDashboardPets'
import PetsSelf from './UserDashboardPetsMySelf'
import Projects from './UserDashboardProjects'
import Transactions from './UserDashboardTabsTransactions'
import Payments from './UserDashboardTabsPayments'
import Follows from './UserDashboardTabsFollows'
import Subscriptions from './UserDashboardSubscriptions'
import Notifications from './UserDashboardNotice'
import Facilities from './UserDashboardFacilities'

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/locale/en';

export default {
    name: "UserDashboard",
    props: ['user'],
    components: {StoryLine, DatePicker, Info, MetaInfo, Pets, PetsSelf, Projects, Transactions, Payments, Follows, Subscriptions, Notifications, Facilities},

    data(){
        return{
            stories: null,
            media: 0,
            lang: {
                monthFormat: 'MMMM'
            },
            date: null,
        }
    },

    created() {
        this.myEventHandler()
        window.addEventListener("resize", this.myEventHandler);
    },
    destroyed() {
        window.removeEventListener("resize", this.myEventHandler);
    },


    async mounted(){
      await this.getDashboard()
      this.fetchFollows();
      this.getFollowHistories();
    },

    computed:{
        ...mapGetters({
            follows: 'getFollows',
            dashboard: 'getterDashboard',
        })

    },

    methods:{
        ...mapActions(['fetchFollows', 'getDashboard']),

        myEventHandler(e){
            this.media = window.innerWidth
        },

        getFollowHistories() {
            axios.get(`/api/histories/last-histories`, {params: {limit: 20, is_only_follows: 1}})
                .then(response => {
                    response = response.data;
                    if (response.success) {
                        this.stories = response.data
                    }
                });
        },

    }


}
</script>

<style scoped>

</style>
